import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../api/axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const token = localStorage.getItem('token');
        if (storedUser && token) {
            setUser(JSON.parse(storedUser));
        }
        setLoading(false);
    }, []);

    const login = async (idOrEmail, password = null) => {
        try {
            const response = await api.post('/auth/login', { login: idOrEmail, password });
            const { token, user } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('user', JSON.stringify(user));
            setUser(user);
            return { success: true };
        } catch (error) {
            return { 
                success: false, 
                message: error.response?.data?.message || 'Login failed' 
            };
        }
    };

    const register = async (userData) => {
        try {
            await api.post('/auth/register', userData);
            return { success: true };
        } catch (error) {
            return { 
                success: false, 
                message: error.response?.data?.message || 'Registration failed' 
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setUser(null);
    };

    const updateUser = (updatedUser) => {
        localStorage.setItem('user', JSON.stringify(updatedUser));
        setUser(updatedUser);
    };

    // Polling en tiempo real cada 0.5s (500ms) para validar cambios de estado de asistencia y perfil de forma síncrona
    useEffect(() => {
        if (!user?.id) return;

        let isMounted = true;
        const checkAttendanceStatus = async () => {
            try {
                const res = await api.get(`/users/${user.id}`);
                const latestUser = res.data;
                if (latestUser && isMounted) {
                    const hasAttendanceChanged = 
                        latestUser.asistencia_evento !== user.asistencia_evento ||
                        latestUser.asistire !== user.asistire ||
                        latestUser.city !== user.city ||
                        latestUser.name !== user.name ||
                        latestUser.role !== user.role;

                    if (hasAttendanceChanged || JSON.stringify(latestUser) !== JSON.stringify(user)) {
                        updateUser(latestUser);
                    }
                }
            } catch (err) {
                // Captura silenciosa para mantener fluidez constante de la interfaz
            }
        };

        const interval = setInterval(checkAttendanceStatus, 500);
        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, [user]);

    return (
        <AuthContext.Provider value={{ user, login, register, logout, loading, updateUser }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
